import { css } from 'styled-components';
import devices from '../shared/styles/devices.js';
import { theme } from '../shared/styles/theme.js';
const linkItem = css`
  font-size: 16px;
  line-height: 1.3;
  opacity: 0.7;
  color: ${theme.airdrop.color.grey80};
  text-decoration: none;
  max-width: 200px;
  @media (${devices.phone_small}) {
    max-width: none;
  }
`;
export { linkItem };
//# sourceMappingURL=FooterLink.js.map
